import { CurrentDevice } from '@libs/types/response'
import { VirtualMG68ACE_W, VirtualMG68ACE_W_24g, VirtualMg68Max, VirtualMg68Max_24g, type DefineDevice } from '../../define/define'
import { deviceManager } from '../../device/device_manager'
import { dataProfileManage } from '@hid/snapshot/profile'

export const requestDevice = async () => {
  const res: HIDDevice[] = await deviceManager.request()
  return deviceManager.respOfDevices(res)
}

export const selectDevice = async (pid: DefineDevice) => {
  await deviceManager.connect(pid)
  dataProfileManage().reload()
  const config = dataProfileManage().dataProfile
  if (config.ColorsDynamic.Run) {
    deviceManager.deviceDriver.syncDynamicColor()
  }
  return null
}

export const getCurrentDevice = async () => {
  return deviceManager.getCurrentDevice()
}
const saveDeviceToDeviceID = (deviceID: number) => {
  localStorage.setItem('deviceID', deviceID.toString())
}

const getDeviceIDFromStorage = (): number | null => {
  const stored = localStorage.getItem('deviceID')
  return stored ? Number(stored) : null
}
const findDevice = (devices: CurrentDevice[], ids: number[]): CurrentDevice | undefined => {
  return devices.find((device) => ids.includes(device.ID))
}
const process24gDevice = (devices: CurrentDevice[]) => {
  const device24g = findDevice(devices, [VirtualMg68Max_24g, VirtualMG68ACE_W_24g])
  if (!device24g) return

  const storedDeviceId = getDeviceIDFromStorage()
  if (storedDeviceId === VirtualMG68ACE_W) {
    devices.forEach((device) => {
      if (device.ID === VirtualMg68Max_24g) {
        device.ID = VirtualMG68ACE_W_24g
      }
    })
  }
}
export const getDeviceList = async (): Promise<CurrentDevice[]> => {
  const devices = await deviceManager.webDevices()
  const deviceList = deviceManager.respOfDevices(devices)
  const mgDevice = findDevice(deviceList, [VirtualMg68Max, VirtualMG68ACE_W])
  if (mgDevice) saveDeviceToDeviceID(mgDevice.ID)

  process24gDevice(deviceList)
  return deviceList
}

export const forgetDevice = async () => {
  return deviceManager.forgetDevice()
}

export const handleDeviceUpdate = async (arrayBuffer: number[]): Promise<boolean> => {
  return deviceManager.deviceDriver.updateFirmware(arrayBuffer)
}
